import en from '@/lang/en.json';
import zh from '@/lang/zh.json';

export const findIntl = (code: string): string => {
  const lang =
    typeof navigator !== 'undefined' && navigator.language?.startsWith('zh') ? zh : en;
  return (lang as any)[code] || '';
};
